import { DefaultState } from 'store/reducers/types';

export const READ_METRO_RECRUITERS_DATA_REQUEST = "READ_METRO_RECRUITERS_DATA_REQUEST";
export const READ_METRO_RECRUITERS_DATA_SUCCESS = "READ_METRO_RECRUITERS_DATA_SUCCESS";
export const READ_METRO_RECRUITERS_DATA_FAILURE = "READ_METRO_RECRUITERS_DATA_FAILURE";

export interface MetroRecruitersRow {
  filledPercent: string;
  id: number;
  lastJobComment: string;
  leftCand: number;
  leftSlots: number;
  name: string;
  neededCand: number;
  neededFromExternal: string;
  neededSlots: number;
  newSignups: string;
  notCalled: string;
  weight: number;
};

export interface MetroRecruitersData {
  rows: MetroRecruitersRow[] | [];
  totalCount: number;
};

export type MetroRecruitersState = DefaultState & {
  contents?: MetroRecruitersData;
};

interface ReadMetroRecruitersDataRequest {
  type: typeof READ_METRO_RECRUITERS_DATA_REQUEST;
};

interface ReadMetroRecruitersDataSuccess {
  type: typeof READ_METRO_RECRUITERS_DATA_SUCCESS;
  contents: MetroRecruitersData;
}

interface ReadMetroRecruitersDataFailure {
  type: typeof READ_METRO_RECRUITERS_DATA_FAILURE;
}

export type ReadMetroRecruitersActionTypes = ReadMetroRecruitersDataRequest | ReadMetroRecruitersDataSuccess | ReadMetroRecruitersDataFailure;